import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    connectionString: import.meta.env.VITE_APPLICATION_INSIGHTS_CONNECTIONSTRING,
    enableAutoRouteTracking: true,
    disableInstrumentationKeyValidation: true,
    extensions: [reactPlugin],
  },
});

// activate insights when running a build, this does mean that insights is not running anymore when developing.
if (import.meta.env.PROD) {
  appInsights.loadAppInsights();
  appInsights.trackPageView();
}

export { reactPlugin, appInsights };
